import { Box, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { IUserProfile } from "MVVM/@types";
import { Avatar } from "../../../AvatarV2";

interface ISharedFollowsProps {
  sharedFollows: IUserProfile[];
}

export const SharedFollows = ({ sharedFollows }: ISharedFollowsProps) => {
  if (!sharedFollows || sharedFollows.length === 0) return null;

  return (
    <FollowedBySection my={2}>
      <FollowedByAvatars>
        {sharedFollows.slice(0, 3).map((follower: IUserProfile) => (
          <FollowedByAvatar key={follower._id}>
            <AvatarWrapper>
              <Avatar
                src={follower.avatarUrl}
                size="sm"
                link={`/u/${follower._id}`}
              />
            </AvatarWrapper>
          </FollowedByAvatar>
        ))}
      </FollowedByAvatars>
      <FollowedByText>
        Followed by{" "}
        {sharedFollows.length === 1 && (
          <HighlightedUsername as="a" href={`/u/${sharedFollows[0]?._id}`}>
            {sharedFollows[0]?.username}
          </HighlightedUsername>
        )}
        {sharedFollows.length === 2 && (
          <>
            <HighlightedUsername as="a" href={`/u/${sharedFollows[0]?._id}`}>
              {sharedFollows[0]?.username}
            </HighlightedUsername>
            {" and "}
            <HighlightedUsername as="a" href={`/u/${sharedFollows[1]?._id}`}>
              {sharedFollows[1]?.username}
            </HighlightedUsername>
          </>
        )}
        {sharedFollows.length >= 3 && (
          <>
            <HighlightedUsername as="a" href={`/u/${sharedFollows[0]?._id}`}>
              {sharedFollows[0]?.username}
            </HighlightedUsername>
            {", "}
            <HighlightedUsername as="a" href={`/u/${sharedFollows[1]?._id}`}>
              {sharedFollows[1]?.username}
            </HighlightedUsername>
            {sharedFollows.length === 3 ? (
              <>
                {", and "}
                <HighlightedUsername
                  as="a"
                  href={`/u/${sharedFollows[2]?._id}`}
                >
                  {sharedFollows[2]?.username}
                </HighlightedUsername>
              </>
            ) : (
              <>
                {", and "}
                <HighlightedUsername as="span">
                  {sharedFollows.length - 2} others
                </HighlightedUsername>
              </>
            )}
          </>
        )}
      </FollowedByText>
    </FollowedBySection>
  );
};

const HighlightedUsername = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const FollowedBySection = styled(Flex)`
  align-items: center;
  gap: 8px;
`;

const FollowedByAvatars = styled(Flex)`
  align-items: center;
  flex-shrink: 0;
`;

const AvatarWrapper = styled(Box)`
  border: 2px solid ${({ theme }) => theme.colors.navy300};
  border-radius: 50%;
  box-sizing: border-box;
  height: 24px;
  overflow: hidden;
  width: 24px;

  /* Reset any Avatar styling to fit our container */
  * {
    border: none !important;
    border-radius: 50% !important;
    height: 100% !important;
    width: 100% !important;
  }
`;

const FollowedByAvatar = styled(Box)`
  position: relative;

  &:first-child {
    margin-left: 0;
    z-index: 3;
  }

  &:nth-child(2) {
    margin-left: -8px;
    z-index: 2;
  }

  &:nth-child(3) {
    margin-left: -8px;
    z-index: 1;
  }
`;

const FollowedByText = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  margin-left: 2px;
`;
